module.exports = __webpack_public_path__ + "52d562e3eee802d2670df64f5b3c54ba.glb";